export var skeletonCircleTheme = {
  baseStyle: {
    borderRadius: 'full',
    backgroundColor: 'neutral.dark'
  }
};
//# sourceMappingURL=SkeletonCircle.theme.js.map